/**
 * Anatomy for localized findings' "radiates" property.
 */
export class Anatomy {
  private static _values: Anatomy[] = [];
  private static _valuesHierarchy: Anatomy[] = [];
  private static _lookup: Map<number, Anatomy> = new Map();

  static fromId(id: number) {
    const anatomy = Anatomy._lookup.get(id);
    if (anatomy === undefined) {
      throw new Error('Not a valid Anatomy.id: ' + id);
    }
    return anatomy;
  }

  static valuesHierarchy(): Anatomy[] {
    return [...Anatomy._valuesHierarchy];
  }

  static values(): Anatomy[] {
    return [...Anatomy._values];
  }

  static size(): number {
    return Anatomy._values.length;
  }

  // ---

  public readonly id: number;
  public readonly label: string;
  public readonly isSelectable: boolean;

  public readonly level: number;
  protected readonly _children: Anatomy[];

  constructor(id: number, label: string, isSelectable: boolean, level: number) {
    this.id = id;
    this.label = label;
    this.isSelectable = isSelectable;

    this.level = level;
    this._children = [];
    Anatomy._lookup.set(id, this);
  }

  hasChildren(): boolean {
    return this._children.length > 0;
  }

  children(): Anatomy[] {
    return [...this._children];
  }

  toJson(): { id: number; name: string } {
    return { id: this.id, name: this.label };
  }

  toString(): string {
    return '<Anatomy: ' + this.id + ", label='" + this.label + "'>";
  }
}

/**
 * Parse the preloaded anatomy data into Anatomy instances.
 *
 * @param data The preloaded data
 */
export const configureAnatomy = (data: any[]): void => {
  const parse = (data: any[], level: number, parent?: Anatomy) => {
    data.forEach((item: any) => {
      const anatomy = new Anatomy(item.id, item.name, item.is_selectable, level);
      // Add to values listings
      (Anatomy as any)._values.push(anatomy);
      if (level === 1) {
        (Anatomy as any)._valuesHierarchy.push(anatomy);
      }
      // Parent-child relationships
      if (parent) {
        (parent as any)._children.push(anatomy);
      }
      if (item.children && item.children.length) {
        parse(item.children, level + 1, anatomy);
      }
    });
  };

  parse(data, 1);
};
